<script lang="ts">
  import { getContext } from 'svelte';
  import clsx from 'clsx';
  import { tabsContextKey, type TabPanelProps, type TabsContext } from './types';

  const { children }: TabPanelProps = $props();
  const context = getContext<TabsContext>(tabsContextKey);
  let tabNumber = $state<undefined | number>(undefined);
  $effect(() => {
    tabNumber = ++context.renderedTabPanels;
    return () => {
      --context.renderedTabPanels;
    };
  });
  const tabId = $derived(tabNumber ? context.tabId(tabNumber) : undefined);
  const panelId = $derived(tabNumber ? context.panelId(tabNumber) : undefined);
</script>

<div
  class={clsx(tabNumber === context.activeTab() ? 'block' : 'hidden')}
  id={panelId}
  role="tabpanel"
  tabindex="0"
  aria-labelledby={tabId}
  hidden={tabNumber !== context.activeTab()}
>
  {@render children()}
</div>
